<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style>
body{
	width: 100% !important;
	height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue